const buildConfig = {
  apiBaseURL: process.env.VUE_APP_API_BASE_URL,
  websiteBaseURL: process.env.VUE_APP_WEBSITE_BASE_URL,
  apiTimeout: process.env.VUE_APP_API_TIMEOUT,
  cookieDomain: process.env.VUE_APP_COOKIE_DOMAIN,
  fbAppId: process.env.VUE_APP_FB_APP_ID,
  maxPerPage: process.env.VUE_APP_MAX_PER_PAGE,
  customerLevels: ["BV_BASIC", "BV_PREMIUM", "BV_VIP"],
  gtmDebug: process.env.VUE_APP_GTM_DEBUG,
  gtmId: process.env.VUE_APP_GTM_ID,
  chat: {
    messageLimit: Number(process.env.VUE_APP_CHAT_MESSAGE_LIMIT) || 100,
    bestvalueReaderUser: process.env.VUE_APP_CHAT_USER_BESTVALUE_READER,
    bestvalueUser: process.env.VUE_APP_CHAT_USER_BESTVALUE,
    bestvalueBroadcastRoom: process.env.VUE_APP_CHAT_BESTVALUE_BROADCAST_ROOM,
  },
  pusher: {
    chatkit: {
      instanceLocator: process.env.VUE_APP_PUSHER_CHATKIT_INSTANCE_LOCATOR,
      tokenProviderUrl: process.env.VUE_APP_PUSHER_CHATKIT_TOKEN_PROVIDER_URL,
    },
  },
};

const runtimeConfig = window.vueRuntimeConfig || {};

export default { ...buildConfig, ...runtimeConfig };
